<template>
    <el-dialog
        :title="$t(`admin.${this.type}`)"
        :close-on-click-modal="false"
        :visible="true"
        width="400px"
        @close="close"
    >
    <div class="flex item-center">
        <i class="required-cls">*</i>
        <el-input v-if="type === 'entityName'"
            v-model="entityName" 
            style="width: 100%"
            clearable
            filterable>
        </el-input>
        <el-date-picker v-else-if="type === 'signingDate'"
            v-model="signingDate"
            value-format="yyyy-MM-dd"
            class="w-full"
            type="date"
        >
        </el-date-picker>
        <el-input v-else
            v-model="description" 
            style="width: 100%"
            clearable
            filterable>
        </el-input>
    </div>
        <span slot="footer" class="dialog-footer">
            <el-button class="wl-green" @click="onConfirmHere">{{ $t('btn_submit') }}</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    name: 'UpdateEntityName',
    data() {return {
        entityName:'',
        signingDate:null,
        description:''
    }},
    props: {
        show: {
            type: Boolean,
            default: false
        },
        onConfirm: {
            type: Function,
            default: () => {}
        },
        value: {
            type: String|Date,
            default: ''
        },
        type:{
            type: String,
            default: 'entityName'
        },
    },
    methods: {
        async onConfirmHere() {
            if(!this.entityName&&this.type === 'entityName'){
                this.$message.error(this.$t('admin.enterTip',{name:this.$t('admin.entityName')}))
            }else if(!this.signingDate&&this.type === 'signingDate'){
                this.$message.error(this.$t('admin.selTip',{name:this.$t('admin.signingDate')}))
            }else if(!this.description&&this.type === 'description'){
                this.$message.error(this.$t('admin.enterTip',{name:this.$t('admin.description')}))
            }else{
                const params = this[this.type]
                this.onConfirm && this.onConfirm(params)
            }  
        },
        close(){
            this.$emit('close')
        }
    },
    mounted(){
         
       
        if(this.type === 'entityName'){
            this.entityName = this.value
        }else if(this.type === 'signingDate'){
            this.signingDate = this.value;
        }else{
            this.description = this.value;
        }
    },
}
</script>
<style scoped>
.required-cls{
        color:#fd349c;
        font-size: 14px;
        margin-right: 5px;
}
</style>